import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchCreditNotes = async (query) => {
  const { data } = await apiClient.get(`/credit-notes`, { params: query.queryKey[1] });
  return data;
};

export const useGetCreditNotesHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [creditNotes, setCreditNotes] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['credit_notes', { ...searchQuery }], // A unique key for this query
    queryFn: fetchCreditNotes,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setCreditNotes(fetchedData.credit_notes);
      setTotalDocuments(fetchedData.totalDocuments);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    creditNotes,
    totalDocuments,
    isLoading,
  };
};
